












import Vue from 'vue';
import { BFormInput } from 'bootstrap-vue';
import { ZenFormGroup } from 'zenComponents';

export default Vue.extend({
  name: 'RiskCardText',
  components: {
    BFormInput,
    ZenFormGroup,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.focus) {
      this.$refs.input.$el.select();
    }
  },
});
